import { ww } from '../partials/windowWidth';

/**
 * Decide whether the header should be sticky or not.
 */
handleStickyHeader = function($) {
    var $header = $('.header-website');
    var headerheight = $('.header-top').outerHeight();
    var navheight = $('header .header-main').outerHeight();
    var stickyClasses = ['fixed', 'top-0', 'left-0', 'w-full'];

    // Always sticky on mobile, sticky from 44px onwards on desktop.
    if(ww.getWindowWidth() >= 768 && $(window).scrollTop() >= 1) {
        // $('header').css('padding-bottom', navheight + 'px');
        $('header .header-main').addClass('active');
        $header.removeClass('relative');
        stickyClasses.forEach(elem => $header.addClass(elem));
        setMenuState('active');
    } else {
        $header.addClass('relative');
        stickyClasses.forEach(elem => $header.removeClass(elem));
        // $('header').css('padding-bottom', '0px');
        // $('header .header-main').removeClass('active');
        setMenuState('inactive');
    }
}

const setMenuState = function(state) {
    let siteLogo = document.querySelector('.logo-default');

    // if( state === 'active' ) {
    //     document.querySelector('.header-main').classList.add('active');
    //     siteLogo.classList.remove("filter-white");
    // } else {
    //     if( window.scrollY == 0 ) {
    //         document.querySelector('.header-main').classList.remove('active');
    //         siteLogo.classList.add("filter-white");
    //     }
    // }

}


module.exports = function($, Modernizr) {
    $(document).ready(function() {
        // Dropdown mobile navigation.
        let $mainMenu = $('.main-menu-container'),
            $menuReveal = $('#menu-reveal');
            $menuHide = $('#menu-hide');

        $('#menu-reveal').click(function(e) {
            e.preventDefault();
            // show menu
            $mainMenu.addClass('translate-x-0').removeClass('translate-x-full');
            // hide current button
            $menuReveal.addClass('hidden');
            // show close button
            $menuHide.removeClass('hidden');
        });

        $('#menu-hide').click(function(e) {
            e.preventDefault();
            // hide menu
            $mainMenu.removeClass('translate-x-0').addClass('translate-x-full');
            // hide current button
            $menuHide.addClass('hidden');
            // show close button
            $menuReveal.removeClass('hidden');
            // reset menus
            let menuBackBtns = document.querySelectorAll('.sub-menu-back');
            menuBackBtns.forEach(elem => {
                elem.parentElement.classList.remove('-translate-x-full')
            })
        });

        // click arrow right on level 1 menu items shows sub menu
        $('.menu-item-level-1 > a').on('click', function(e) {
            if( e.target.classList.contains('view-sub-menu') || e.target.classList.contains('fa-arrow-right') ) {
                e.preventDefault();
                // show child menu
                let $childMenu = $(this).next('.sub-menu-container');
                $childMenu.addClass('-translate-x-full');
            }
        });

        // close the child menu
        $('.sub-menu-back').on('click', function(e) {
            e.target.parentElement.classList.remove('-translate-x-full')
        });
        $('.sub-menu-back').on('click', '*', function(e) {
            e.target.parentElement.parentElement.classList.remove('-translate-x-full')
        });

        // Clicking a li element on mobile shows its dropdown.
        // $('.menu-item-has-children').click(function(e) {
        //     e.stopPropagation();

        //     if($(window).width() < 992) {
        //         $(this).toggleClass('toggled');
        //     }
        // });

        let levelOneItems = document.querySelectorAll('.menu-item-level-1');
        levelOneItems.forEach(item => {
            item.addEventListener('mouseenter', function(e) {
                setMenuState('active');

            })
            item.addEventListener('mouseleave', function(e) {
                setMenuState('inactive');
            })
        })
        // $('.menu-level-1').on('hover', function(e) {
        //     alert('hi');
        //     // let windowWidth = ww.getWindowWidth();
        //     // if( windowWidth > 767 ) {
        //     //     $('.header-main').addClass('active');
        //     // }
        // })

        // handleStickyHeader($);
    })

    document.addEventListener('scroll', function() {
        handleStickyHeader($);
    }, Modernizr.passiveeventlisteners ? {passive: true} : false);
}
